// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-chip[data-v-5de5a9c8] {\r\n  width: 7rem;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: left;\r\n      -ms-flex-pack: left;\r\n          justify-content: left;\r\n  -webkit-box-align: left;\r\n      -ms-flex-align: left;\r\n          align-items: left;\r\n  padding-top: 2px;\r\n  padding-left: 3px;\n}\r\n", ""]);
// Exports
module.exports = exports;
